import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../features/auth/authApi";

export default function LoginForm({ roleType }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const [login, { data, isLoading, error: loginError }] = useLoginMutation();

  useEffect(() => {
    if (loginError?.data) {
      setError(loginError.data);
    }
    if (data?.accessToken && data?.user) {
      if (roleType !== data?.user?.role) {
        setError('User not found!')
        return;
      }

      if (data?.user?.role == 'student') {
        navigate('/course')
      } else {
        navigate('/admin/videos')
      }
    }
  }, [data, loginError, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    setError('');
    login({ data: { email, password }, role: roleType });
  }

  const inputChangeHandler = (e, setState) => {
    setError('')
    setState(e.target.value)
  }

  return (
    <form className="mt-8 space-y-6" onSubmit={submitHandler}>
      <input type="hidden" name="remember" value="true" />
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          <label htmlFor="email-address" className="sr-only">Email address</label>
          <input id="email" name="email" value={email} onChange={e => inputChangeHandler(e, setEmail)} type="email" autoComplete="email" required
            className="login-input rounded-t-md" placeholder="Email address" />
        </div>
        <div>
          <label htmlFor="password" className="sr-only">Password</label>
          <input id="password" name="password" value={password} onChange={e => inputChangeHandler(e, setPassword)} type="password" autoComplete="current-password" required
            className="login-input rounded-b-md" placeholder="Password" />
        </div>
      </div>
      {error !== '' ? <span className="text-center block text-red-600  w-full p-0">{error}</span> : null}
      {roleType == 'student' &&
        <div className="flex items-center justify-end">
          <div className="text-sm">
            <Link to={'/signup'} className="font-medium text-violet-600 hover:text-violet-500">
              Create New Account
            </Link>
          </div>
        </div>
      }

      <div>
        <button type="submit" disabled={isLoading} className="group cursor-pointer relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
          Sign in
        </button>
      </div>
    </form>
  )
}